/* =========================================================
   CUSTOM SLIDESHOW (Vanilla)
   Fixes "images not showing" by setting container height
   because slides are position:absolute.
========================================================= */

(function () {
  const SELECTOR = ".slideshow[data-init-slideshow]";

  const iconPrev = `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M15.5 4.5 8 12l7.5 7.5-1.5 1.5L5 12l9-9 1.5 1.5z"/>
    </svg>`;
  const iconNext = `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8.5 19.5 16 12 8.5 4.5 10 3l9 9-9 9-1.5-1.5z"/>
    </svg>`;

  const toBool = (v) => String(v).toLowerCase() === "true";

  function setHeightToActive(slideshow) {
    const active = slideshow.querySelector(".item.is-active");
    if (!active) return;

    // Prefer adaptive_height container if present
    const box =
      active.querySelector(".adaptive_height") ||
      active.querySelector(".fluid-width-video-wrapper") ||
      active;

    // Measure visible height
    const h = Math.ceil(box.getBoundingClientRect().height);

    // If height is 0 (image not loaded yet), try again shortly
    if (!h) {
      requestAnimationFrame(() => {
        const h2 = Math.ceil(box.getBoundingClientRect().height);
        if (h2) slideshow.style.height = h2 + "px";
      });
      return;
    }

    slideshow.style.height = h + "px";
  }

  function onImagesReady(slideshow, cb) {
    const imgs = Array.from(slideshow.querySelectorAll("img"));
    let pending = 0;

    imgs.forEach((img) => {
      // If using lazyload, it may swap src later — still listen for load
      if (img.complete && img.naturalWidth > 0) return;
      pending++;
      img.addEventListener(
        "load",
        () => {
          pending--;
          if (pending <= 0) cb();
        },
        { once: true }
      );
      img.addEventListener(
        "error",
        () => {
          pending--;
          if (pending <= 0) cb();
        },
        { once: true }
      );
    });

    // If nothing pending, run now
    if (pending === 0) cb();
  }

  function initSlideshow(slideshow) {
    if (slideshow.dataset.csInit === "1") return;
    slideshow.dataset.csInit = "1";

    const slides = Array.from(slideshow.querySelectorAll(":scope > .item"));
    if (slides.length === 0) return;

    // Wrap in track (safe)
    if (!slideshow.querySelector(":scope > .slideshow-track")) {
      const track = document.createElement("div");
      track.className = "slideshow-track";
      slides.forEach((s) => track.appendChild(s));
      slideshow.appendChild(track);
    }

    const settings = {
      arrows: toBool(slideshow.dataset.arrows),
      dots: (slideshow.dataset.dots || "shape").toLowerCase(), // none|shape|number
      autoplay: toBool(slideshow.dataset.autoplay),
      speed: parseInt(slideshow.dataset.autoplaySpeed || "5000", 10),
    };

    let index = 0;
    let timer = null;

    function setActive(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle("is-active", idx === index));

      if (dotsWrap) {
        Array.from(dotsWrap.children).forEach((li, idx) =>
          li.classList.toggle("is-active", idx === index)
        );
      }

      // Critical: adjust height
      setHeightToActive(slideshow);
    }

    function next() { setActive(index + 1); }
    function prev() { setActive(index - 1); }

    function start() {
      stop();
      if (!settings.autoplay || slides.length <= 1) return;
      const ms = Math.max(1000, Math.min(60000, settings.speed || 5000));
      timer = setInterval(next, ms);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Controls
    let dotsWrap = null;

    if (settings.arrows && slides.length > 1) {
      const prevBtn = document.createElement("button");
      prevBtn.type = "button";
      prevBtn.className = "cs-arrow cs-prev";
      prevBtn.setAttribute("aria-label", "Previous slide");
      prevBtn.innerHTML = iconPrev;

      const nextBtn = document.createElement("button");
      nextBtn.type = "button";
      nextBtn.className = "cs-arrow cs-next";
      nextBtn.setAttribute("aria-label", "Next slide");
      nextBtn.innerHTML = iconNext;

      prevBtn.addEventListener("click", () => { prev(); start(); });
      nextBtn.addEventListener("click", () => { next(); start(); });

      slideshow.appendChild(prevBtn);
      slideshow.appendChild(nextBtn);
    }

    if (settings.dots !== "none" && slides.length > 1) {
      dotsWrap = document.createElement("ul");
      dotsWrap.className = "cs-dots";
      if (settings.dots === "number") slideshow.classList.add("cs-dots-number");

      slides.forEach((_, i) => {
        const li = document.createElement("li");
        const btn = document.createElement("button");
        btn.type = "button";
        btn.setAttribute("aria-label", `Go to slide ${i + 1}`);
        btn.textContent = settings.dots === "number" ? `${i + 1}/${slides.length}` : "";
        btn.addEventListener("click", () => { setActive(i); start(); });
        li.appendChild(btn);
        dotsWrap.appendChild(li);
      });

      slideshow.appendChild(dotsWrap);
    }

    // Hover pause
    slideshow.addEventListener("mouseenter", stop);
    slideshow.addEventListener("mouseleave", start);

    // Resize update
    window.addEventListener("resize", () => setHeightToActive(slideshow));

    // Init first slide
    setActive(0);

    // When images finally load (lazyload etc.), update height again
    onImagesReady(slideshow, () => setHeightToActive(slideshow));

    // Start autoplay
    start();
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSlideshow);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
